import React from 'react'
import {
ContainerFluid,HeadingText,Container,ParagraphText,ContainerFluidB,ContainerFluidC
} from './SectionAComponent.style';
function SectionAComponent() {
  return (
    <div>
      <ContainerFluid>
        <Container>
          <br/>
          <br/>
          <div className='row'>
            <div className='col s12 m12 l12 '>
              <ParagraphText>
                We at Yalla Technologies respect your privacy and are committed to protecting it through our compliance with these 
                Privacy Policy. Please read this Policy carefully to understand our policies and practices regarding your data and how 
                we will use it. 
              </ParagraphText>
            </div>
          </div>
        </Container>
      </ContainerFluid>
      <ContainerFluidB>
        <Container>
        <div className='row'>
            <div className='col s12 m12 l12'>
              <ParagraphText>
                <b>Application of this Privacy Policy.</b><br/>
                This Privacy Policy explains how Yalla Technologies collect, disclose, use and store your personal information. This 
                Privacy Policy applies to Yalla Technologies websites, applications, other online services, and/related to services, sales, 
                marketing, promotional or events, and social media activities. This Privacy Policy also applies to Yalla Technologies 
                offline.
                By accessing and using Yalla Technologies services, you agree and understand that you will be bound by this 
                Privacy Policy.
              </ParagraphText>

              <ParagraphText>
                <b>Collection of Personal Data</b><br/>
                When you register an account with Yalla Technologies, submit an inquiry to us through any means, register to attend 
                any of our events, interact with us on social media and volunteer information to us, we may collect personal data from 
                you which may include your name, address, phone number, email, date of birth, bank account details, your BVN, 
                username, password, details of your next of kin and any other information that can be used to identify you. 
                Also, in general, we collect Personal data you give us by filling in forms, surveys, or by corresponding with us by phone, 
                emails, social media post, among other things. We collect your Personal data about your transactions with us and 
                others. <br/><br/>

                We may collect your Personal data from non affiliated third party service providers. For instance, we receive Personal 
                information about you from consumer reporting agencies, from your employer; where you employer is providing a 
                service for Yalla Technologies, or where your Personal data is filled in a next-of - kin form. <br/><br/>

                When you use our services, we automatically collect the following data:
                -Usage details such as traffic data, location data, logs, other communication data and the resources you access and 
                use through our Platforms;
                - Including mobile devices, unique device identifiers, IP address, internet connection, operating system, browser type 
                and mobile network information (including mobile phone number);
                -Information and files stored on your device;
                - Location of your device and it IP address while Yalla Technologies are in use. This would be collected with your consent 
                -Information collected by cookies and other tracking technologies. We use several technologies to get information on 
                our services and other websites, this may include sending cookies to your computer or mobile device. Cookies are 
                small files stored on your hard drive or device memory that help us improve our services and your experiences using 
                our products. We may also collect your data through small electronic files called Web beacons (also known as clear gifs, 
                pixel tags and single-pixel gifs) that may for instance permit Yalla Technologies to count users who have visited those 
                pages, opened an email,  other related statistics and as well as recording the popularity of some of our App/Website 
                contents, verifying system and server integrity. <br/><br/>

                When you use our App or its content, certain third parties may use automatic information collection technologies to 
                collect information about you or your device. These third parties may include App store, Google play store, platform 
                providers and Analytics companies. <br/><br/>

                The personal data we receive from other sources such as financial institutions, among others, by reason of we working 
                alongside these third parties will be communicated to you and the purposes for which they are requested. <br/><br/>
              </ParagraphText>

              <ParagraphText>
                <b>Use of Personal Data</b><br/>
                What we use your Personal data for includes:<br/>
                - The provision, maintenance and improvement of our services;<br/>
                -The provision and deliverance of products and services you ask for, process transactions and send you related 
                information, including confirmation;<br/>
                - Send you support and administrative measages, updates, security alerts, and notices;<br/>
                - Verify your identity and prevent fraudulent acts or illegal activities;<br/>
                - Respond to your inquires and provide outstanding customer support;<br/>
                - Commercial purposes to offer our products and services or the product and services of third parties we think might 
                interest or is relevant to you;<br/>
                - Comply with Applicable laws<br/><br/>

                Yalla Technologies is based in Nigeria and the Personal Data we collect is governed by the Nigeria Data Protection 
                Regulation (NDPR). By accessing or using the Services or otherwise providing your Personal Data to us, you consent to 
                the processing and transfer of your Personal Data in and to Nigeria and other countries.<br/>
              </ParagraphText>
              
              <ParagraphText>
                <b>How We Share Personal Data </b><br/>
                Your Personal data are not shared with:<br/>
                -Other financial companies for joint marketing purposes;<br/>
                -Affiliated companies for their everyday business purposes; or<br/>
                -Any third parties so they can market to you.<br/>

                However, we may share your Personal data with unaffiliated third parties where:<br/>
                -You request or authorize it;<br/>
                - The data is provided to help complete a transaction for you;<br/>
                - The data is provided to comply with our legal and regulatory obligations;<br/>
                - The data is provided to our third-party service providers to perform functions on our behalf (e.g., analysing data, 
                  providing marketing assistance, providing customer service, processing orders, etc.); <br/>
                - The use your data is necessary to protect your interest, for our legitimate interests or the legitimate interests of others.<br/><br/>

                When you are no longer our User, we may continue to share your data as described in this Privacy Policy.<br/>
              </ParagraphText>
              <ParagraphText>
                <b>Your Rights </b><br/>
                In the event you do not wish to receive promotional messages, offers or notices from us in the future, you can opt out 
                by contacting us or follow the "unsubscribe" instructions you receive from us. Please note that as a user of our 
                services, you are not able to opt out of communications about your Yalla account or related transactions with us.<br/><br/>

                You also have the option of exercising any of your following rights:<br/>
                - Set your computer or mobile device to refuse all cookies or some of it or to get notified when cookies are being sent 
                to you. If you disable, block or refuse cookies, some parts of our services may become inaccessible to you or not 
                function properly.<br/>
                - Request correction of your personal data. If you are a User, you can change some of your Personal Information by 
                updating your Yalla  account profile through our Services. Changes to financial details will require you to contact us 
                directly. Any changes will affect only future uses of your Personal data  and we may need to verify the accuracy of the 
                new data you provide to us.<br/>
                - Request access to your personal data. Before sending you any Personal data, we will ask you to provide proof of your 
                identity. If you are not able to provide proof of your identity, we reserve the right to refuse to send you any Personal 
                Information.<br/>
                - Object the processing of your personal data where you feel it impacts on your fundamental rights and freedoms. 
                You also have the right to object where we are processing your personal data for direct marketing purposes. In some 
                cases, we may demonstrate that we have compelling legitimate grounds to process your information which override 
                your rights and freedoms. <br/>
                - Request transfer of personal data to third party.<br/>
              </ParagraphText>

              <ParagraphText>
                <b>Security and Storage of your Personal Data</b><br/>
                We have suitable security measures in place to prevent your Personal data from being accidentally lost or used or 
                accessed in an unauthorised way by a third party. When your bank account information is transmitted via our services, 
                it will be protected by encryption technology, such as Secure Sockets Layer (SSL). In addition, we limit access to your 
                personal data to those employees, agents, contractors and other third parties who have a reason to know. They will 
                only process your Personal Information on our instructions. We have put in place procedures to deal with any 
                suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally 
                required to do so. <br/><br/>

                No method of electronic transmission or storage is 100% secure. Therefore, we cannot guarantee absolute security of 
                your Personal Information. You also play a role in protecting your Personal Information. Once  you have chosen a 
                password that allows you to access certain parts of the website and mobile application, we plead with you to take the 
                responsibility for keeping this password confidential. We advise you not to share your password with anyone.<br/><br/>

                Subject to applicable law, which might, from time to time, oblige us to store your Personal data for a certain period of 
                time, we will retain your Personal Information for as long as required to fulfil the purposes we collected it for, including 
                the purposes of satisfying any legal, accounting, or reporting requirements.<br/>
              </ParagraphText>
              <ParagraphText>
                <b>Changes to Our Privacy Policy</b><br/>
                Subject to applicable law, we may revise this Privacy Policy from time to time and at our sole discretion. When we 
                revise this Privacy Policy, we will post the revised version via our Services and will update the date at the top of this 
                Privacy Policy. The revised Privacy Policy will be effective upon posting via our Services, unless otherwise set forth 
                therein or as otherwise required by applicable law. You are free to choose whether or not to accept a revised version 
                of this Privacy Policy, but accepting this Privacy Policy, as revised, is crucial for your continuous access or use of our 
                Services. If you do not agree to the terms of this Privacy Policy or any revised version of this Privacy Policy, your sole 
                recourse is to terminate your access and use of our Services. Except as otherwise expressly stated by us, your access 
                and use of our Services are subject to the version of this Privacy Policy in effect at the time of access or use.<br/>
              </ParagraphText>
            </div>
          </div>
        </Container>
      </ContainerFluidB>
      
      <ContainerFluidC className=''>
        <Container>
          <div className='row mt-100'>
            <div className='col s12 m12 l7'>
              {/* <br/><br/><br/>
              <HeadingText>
                Contact Us
              </HeadingText>
              <ParagraphText>
                <b>Address:</b> 10, Deji Odunuga, Anthony,  Lagos, Nigeria
              </ParagraphText>
              <ParagraphText>
                <b>Phone number:</b>  +234 818 378 1220  
              </ParagraphText>
              <ParagraphText>
                <b>Email:</b>  hello@yalla.ng
              </ParagraphText> */}
              
            </div>
          </div>
        </Container>
      </ContainerFluidC>
    </div>
  )
}

export default SectionAComponent